import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IColor, IProductColorRequest } from '../models/models'

export class DeleteColorCodeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/color/deleteColorCode',
      requesterInfo,
    })
  }

  public async deleteColor(request: number): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
